import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PhoneNumberHelper } from '../../../helpers/phoneNumber.helper';
import { PrefixModel } from '../../../models/phone-number.model';

@Component({
  selector: 'form-phone-input',
  templateUrl: './form-phone-input.component.html',
  styleUrls: ['./form-phone-input.component.scss'],
})
export class FormPhoneInputComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() establishmentNumber = null;
  @Input() isUpdateMode = false;

  prefixes: PrefixModel[] = [];
  selectedCountry: PrefixModel;
  phoneNumber = '';

  constructor() {}

  ngOnInit() {
    this.initData();
    this.initForm();
    this.setupValueChanges();
  }

  initData() {
    this.prefixes = PhoneNumberHelper.loadEUCountries();
    this.selectedCountry = PhoneNumberHelper.getPrefix(this.prefixes);
  }

  initForm() {
    if (this.isUpdateMode && this.establishmentNumber) {
      const matchedPrefix = this.prefixes.find(p => p.code === this.establishmentNumber.prefix?.code);

      this.form.addControl('prefix', new UntypedFormControl(matchedPrefix || this.selectedCountry, Validators.required));
      this.form.addControl(
        'phoneNumber',
        new UntypedFormControl(this.establishmentNumber.phoneNumber || null, this.phoneNumberValidator.bind(this)),
      );
    } else {
      this.form.addControl('prefix', new UntypedFormControl(this.selectedCountry, Validators.required));
      this.form.addControl('phoneNumber', new UntypedFormControl(this.phoneNumber, this.phoneNumberValidator.bind(this)));
    }
  }

  setupValueChanges() {
    this.form.controls.prefix.valueChanges.subscribe(() => {
      this.form.get('phoneNumber')?.updateValueAndValidity({ onlySelf: true });
    });
  }

  phoneNumberValidator(control: any) {
    const phoneNumber = control.value;

    if (!phoneNumber) {
      return null;
    }

    const prefix = this.form.get('prefix')?.value;
    const isValid = PhoneNumberHelper.isValidPhoneFormat(phoneNumber, prefix);

    return isValid ? null : { invalidPhoneNumber: true };
  }

  get isOtherPrefix(): boolean {
    const prefix = this.form.get('prefix')?.value;
    return prefix ? PhoneNumberHelper.isOtherPrefix(prefix) : false;
  }
}
